import { useMutation } from "react-query";
import downloadWithdraw from "../services/downloadWithdraw";

function useDownloadWithdrawCSV() {
  return useMutation(["download-withdraw-pending-csv"], downloadWithdraw);
}

export default useDownloadWithdrawCSV;
